import React, { useEffect, useState } from 'react';
import { Typography, Button, Row, Col, message, Card, Spin, Modal, Progress, Space, Divider, Tooltip, Empty } from 'antd';
import SidebarLayoutConsumer from './SidebarLayoutConsumer';
import { useHistory } from "react-router-dom";
import { routes } from '../../../routes/Routes';
import { COMMON_ERROR_MSG, RECORD_DELETED_MSG } from '../../../constants/constants';
import _AdministratorService from '../../../modules/AdministratorService';
import { RightOutlined, QuestionCircleOutlined, DollarOutlined } from "@ant-design/icons";
import { Pie } from "@ant-design/plots";
import DonutChart from '../../../components/DonutChart';
import _commonService from '../../../modules/commonService';
const { Title, Text } = Typography;
const { confirm } = Modal;

const SponsorsCapitalProvider = () => {
  const history = useHistory();
  const [sponserData, setSponserData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getSponserListByBankerId(localStorage.getItem("administratorUserId"))
  }, []);

  const getSponserListByBankerId = async () => {
    try {
      setLoading(true);

      const res = await _AdministratorService.getSponserListByBankerId(localStorage.getItem("administratorUserId"));

      if (res.data.IsSuccess) {
        setLoading(false);
        setSponserData(res?.data?.Obj?.List);
      } else {
        setLoading(false);
        message.error(res.data.Message || COMMON_ERROR_MSG);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const onFirmsAddClick = () => {
    history.push({ pathname: routes.addEditSponsersForAdministrator.path });
  }


  const onEditSponserClick = (dataObj) => {
    history.push({
      pathname: routes.addEditSponsersForAdministrator.path,
      state: { sponserId: dataObj.Id },
    });
  }

  // const onDeleteSponser = (dataObj) => {
  //   confirm({
  //     title: `Are you sure, want to delete this Firm/Agency (${dataObj.CompanyName})?`,
  //     icon: <ExclamationCircleOutlined />,
  //     okText: <span id="yesBtn">Yes</span>,
  //     cancelText: <span id="noBtn">No</span>,
  //     okType: "primary",
  //     onOk() {
  //       deleteSponser(dataObj.Id);
  //     }
  //   });
  // };

  // const deleteSponser = async (objId) => {
  //   setLoading(true);
  //   try {
  //     const res = await _AdministratorService.deleteSponserBySponserId(objId);
  //     if (res.data.IsSuccess) {
  //       message.success(RECORD_DELETED_MSG);
  //       getSponserListByBankerId(localStorage.getItem("administratorUserId"));
  //     } else {
  //       message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
  //       setLoading(false);
  //     }
  //   } catch (e) {
  //     console.log(e);
  //     setLoading(false);
  //   }
  // };

  
  return (
    <Spin spinning={loading}>
      <SidebarLayoutConsumer>
        <div className='sponsors-capital-provider'>

          <Row className='baseAlign'>
            <Col span={20}>
              <Title level={3}>Capital Provider Dashboard</Title>
              <text>Manage and monitor capital provider activity.</text>
            </Col>
            <Col span={4}>
            <Button
              type="primary"
              className={sponserData && sponserData.length === 1 ? "hide" : ""}
              onClick={onFirmsAddClick}
            >
              Add New Capital Provider
            </Button>
            </Col>
          </Row>

          <Row gutter={[16, 16]} className='capital-provider-list'>
            {sponserData &&
              sponserData.map((dataObj, idx) => {
                const total = Number(
                  dataObj.TotalProgrameSize?.toString().replace(/,/g, "")
                );

                const utilized = Number(
                  dataObj.Utilized?.toString().replace(/,/g, "")
                );

                const remaining = total - utilized;
                return (
                  <Col
                    className="gutter-row"
                    xs={{ span: 24 }}
                    sm={{ span: 12 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 8 }}
                    xxl={{ span: 8 }}
                  >
                    <Card
                      className="cardViewMain"
                      title={
                        <Row justify="space-between" align="middle">
                          <Tooltip title={dataObj.CompanyName}>
                            <span
                              className="f18B"
                            >
                              {dataObj.CompanyName}
                            </span>
                          </Tooltip>

                          <Button
                            type="link"
                            className='viewBtn'
                            onClick={() => onEditSponserClick(dataObj)}
                          >
                            View Details
                            <RightOutlined />
                          </Button>
                        </Row>
                      }

                    >

                      <Row justify="space-around" align="middle">
                        {/* Left - Donut chart */}
                        <Col span={24} className='aligntext donut-chart-col'>
                          <Row justify="center" align="middle">
                            <Col span={4}></Col>
                            <Col span={16} className='aligntext donut-chart-col'>
                              <DonutChart data={[
                                { type: 'Remaining', value: Number(remaining) },
                                { type: 'Utilized', value: Number(dataObj.Utilized) },

                              ]}
                                title="Budget"
                              />
                            </Col>
                            <Col span={4}></Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <div className=' budget-details-div'>
                            <Title level={5}>
                              Utilized:
                            </Title>
                            <span>
                              $ {_commonService.formatNumberWithCommas(dataObj.Utilized)}
                            </span>
                          </div>
                          <div className=' budget-details-div'>
                            <Title level={5}>
                              Remaining:
                            </Title>
                            <span>
                              {

                              }
                              $ {_commonService.formatNumberWithCommas(remaining)}
                            </span>
                          </div>
                          <Divider className='divider' />

                          <div className=' budget-details-div'>
                            <Title level={5}>
                              Total Allocation:
                            </Title>
                            <span>
                              $ {_commonService.formatNumberWithCommas(dataObj.TotalProgrameSize)}
                              {/* ${Number(dataObj.TotalRecords)} + ${Number(dataObj.Remaining)} */}
                            </span>
                          </div>

                          <Divider className='divider' />
                        </Col>
                        <Col span={24}>
                          <Row
                            className="iconFont"
                            align="middle"
                            justify="center"
                            style={{ marginBottom: 16 }}
                          >
                            {/* <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                          <Text strong className="ant-card-head-title" style={{ fontSize: 16, margin: 0 }}>
                            Limit Usage
                          </Text>
                          <Tooltip title="What is Limit Usage?">
                            <span>
                              <QuestionCircleOutlined className="ml10" style={{ fontSize: 16, marginLeft: 8 }} />
                            </span>
                          </Tooltip>
                        </div> */}
                          </Row>
                        </Col>

                        {/* Right - Active Loans */}
                        <Col span={24} className=''>
                          <Row
                            gutter={[16, 16]}
                            className="active-loans-row">
                            <Col span={24}>
                              <Title
                                level={5}
                              >
                                Active Loan Programs
                              </Title>
                            </Col>
                            <Col span={11} className='active-loans-data' style={{ marginRight: "16px" }}>

                              <div className=' budget-details-div-1' >
                                <Title level={5}>
                                  In Progress:
                                </Title>
                                <span>
                                  {_commonService.formatNumberWithCommas(dataObj.Inprogressed)}
                                </span>
                              </div>
                            </Col>

                            <Col span={11} className='active-loans-data'>

                              <div className='budget-details-div-1'>
                                <Title level={5}>
                                  Funded:
                                </Title>
                                <span>
                                  {_commonService.formatNumberWithCommas(dataObj.Approved)}
                                </span>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Card>
                  </Col>

                );
              })}
          </Row>

          {sponserData.length === 0 && (
            <div style={{ textAlign: "center", marginTop: 20 }}>
              <Empty
                image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                styles={{ image: { height: 60 } }}
                description={
                  <Typography.Text>
                    No Capital Providers created yet
                  </Typography.Text>
                }
              />
            </div>
          )}
        </div>
      </SidebarLayoutConsumer>

    </Spin>
  );
};

export default SponsorsCapitalProvider;